<template>
<svg :class="size?`w-${size} h-${size}`:`w-6 h-6`" class="stroke-current inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"/>
</svg>

</template>

<script>
export default {
	name:"IconSelectorOutline",
	props:["size"],
}
</script>